import { API_URL } from '../../../../../../services/config';
import { WrapperHttpService } from '../../../../../services/wrapper-http-service';
import { AllocationViewEndpoint } from '../../constants';
import { AllocationViewActionIdentifierModel } from '../../models';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AllocationViewClearActionService {
  constructor(private http: WrapperHttpService) {}

  uliClear(actionIdentifier: AllocationViewActionIdentifierModel, comment?: string): Observable<void> {
    const url = `${API_URL}${AllocationViewEndpoint.Action}${AllocationViewEndpoint.Clear}`;

    return this.http.withLoading().post<void>(url, { ...actionIdentifier, comment });
  }
}
